enum InfoTypeEnum {
  Success = 'success',
  Error = 'error',
  Information = 'information',
  ContentOverlay = 'content_overlay',
}

export default InfoTypeEnum;
